import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';

const BulkOperationsToolbar = ({ selectedCount, onBulkAction, onClearSelection }) => {
  const [showBulkMenu, setShowBulkMenu] = useState(false);
  const [bulkOperation, setBulkOperation] = useState('');
  const [bulkValue, setBulkValue] = useState('');

  const bulkOperationOptions = [
    { value: '', label: 'Select Operation' },
    { value: 'update-status', label: 'Update Status' },
    { value: 'modify-dates', label: 'Modify Dates' },
    { value: 'change-role', label: 'Change Role' },
    { value: 'reassign-yard', label: 'Reassign Yard' },
    { value: 'export', label: 'Export Selected' },
    { value: 'delete', label: 'Delete Selected' }
  ];

  const statusOptions = [
    { value: 'active', label: 'Active' },
    { value: 'pending', label: 'Pending' },
    { value: 'expired', label: 'Expired' }
  ];

  const roleOptions = [
    { value: 'primary', label: 'Primary Driver' },
    { value: 'relief', label: 'Relief Driver' }
  ];

  const handleBulkAction = () => {
    if (bulkOperation && bulkValue) {
      onBulkAction(bulkOperation, bulkValue);
      setBulkOperation('');
      setBulkValue('');
      setShowBulkMenu(false);
    }
  };

  const renderBulkValueInput = () => {
    switch (bulkOperation) {
      case 'update-status':
        return (
          <Select
            placeholder="Select Status"
            options={statusOptions}
            value={bulkValue}
            onChange={setBulkValue}
            className="w-48"
          />
        );
      case 'change-role':
        return (
          <Select
            placeholder="Select Role"
            options={roleOptions}
            value={bulkValue}
            onChange={setBulkValue}
            className="w-48"
          />
        );
      case 'modify-dates':
        return (
          <Input
            type="date"
            value={bulkValue}
            onChange={(e) => setBulkValue(e?.target?.value)}
            className="w-48"
          />
        );
      default:
        return null;
    }
  };

  if (selectedCount === 0) {
    return null;
  }

  return (
    <div className="bg-primary/10 border border-primary/20 rounded-lg p-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <div className="flex items-center space-x-2">
            <Icon name="CheckSquare" size={20} color="var(--color-primary)" strokeWidth={2} />
            <span className="text-sm font-semibold text-primary">
              {selectedCount} assignment{selectedCount !== 1 ? 's' : ''} selected
            </span>
          </div>

          {!showBulkMenu ? (
            <Button
              variant="default"
              size="sm"
              iconName="Settings"
              onClick={() => setShowBulkMenu(true)}
            >
              Bulk Operations
            </Button>
          ) : (
            <div className="flex items-center space-x-2">
              <Select
                placeholder="Select Operation"
                options={bulkOperationOptions}
                value={bulkOperation}
                onChange={setBulkOperation}
                className="w-56"
              />

              {bulkOperation && renderBulkValueInput()}

              {bulkOperation && bulkValue && (
                <Button
                  variant="default"
                  size="sm"
                  iconName="Check"
                  onClick={handleBulkAction}
                >
                  Apply
                </Button>
              )}

              <Button
                variant="ghost"
                size="sm"
                iconName="X"
                onClick={() => {
                  setShowBulkMenu(false);
                  setBulkOperation('');
                  setBulkValue('');
                }}
              />
            </div>
          )}
        </div>

        <div className="flex items-center space-x-2">
          <Button
            variant="outline"
            size="sm"
            iconName="Download"
            onClick={() => onBulkAction('export', 'selected')}
          >
            Export
          </Button>
          <Button
            variant="ghost"
            size="sm"
            iconName="X"
            onClick={onClearSelection}
          >
            Clear Selection
          </Button>
        </div>
      </div>

      {showBulkMenu && (
        <div className="mt-3 pt-3 border-t border-primary/20">
          <div className="flex items-start space-x-2">
            <Icon name="Info" size={16} color="var(--color-primary)" strokeWidth={2} className="mt-0.5" />
            <p className="text-xs text-primary">
              Bulk operations will be applied to all {selectedCount} selected assignment{selectedCount !== 1 ? 's' : ''}. 
              This action may take a few moments to complete.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default BulkOperationsToolbar;